document.addEventListener("DOMContentLoaded", function() {

    const swiperIndexReferences = new Swiper('.JS-index-references', {
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 1.25,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.swiper-button-next',
        },
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 2.25,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3.25,
                spaceBetween: 30,
            },
            1442: {
                slidesPerView: 2.25,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 3.25,
                spaceBetween: 40,
            }
        }
    });
});
